<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <CRow style="width:85%;"
                          role="dialog"
                          aria-labelledby="modalTitle"
                          aria-describedby="modalDescription">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MEM"][obj_Loyalty.I > 0? "ELP": "ALP"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["MEM"]["LPI"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["PM"]["AGI"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :flat="true"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              v-model="obj_Loyalty.AGIT"
                                                              @input="AgentGroupChange"
                                                              :max-height="200"
                                                              :disabled="obj_Loyalty.I > 0"
                                                              ref="AGI" />
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('AGI') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["CI"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency2"
                                                        :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                                        :disabled="!bool_currencyloaded || obj_Loyalty.I > 0"
                                                        :clearable="false"
                                                        :max-height="200"
                                                        v-model="obj_Loyalty.CI"
                                                        @input="CurrencyChange"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('CI','MEM', 'CI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["LPN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['MEM']['LPN']"
                                                    size="sm"
                                                    :value="obj_Loyalty.LN"
                                                    @change="v => obj_Loyalty.LN = v"
                                                    :disabled="obj_Loyalty.I > 0"
                                                    ref="LN"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('LN','MEM','LPN') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["MEM"]["LPR"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["LPT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_loyaltyGroup"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['MEM']['LPT']"
                                                        @input="LoyaltyGroupChange"
                                                        v-model="obj_Loyalty.LG"
                                                        :max-height="200"
                                                        :disabled="obj_Loyalty.I > 0"
                                                        ref="LG" />
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('LG','MEM','LPT') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group" v-if="obj_Loyalty.LG != 3">
                                            <label class="col-form-label-sm" style="display:block">{{this.getLanguage["MEM"]["S"]}}<span class="required" /> :</label>
                                            <div v-for="(option, optionIndex) in dd_loyaltyStackable" :key="option.id" class="inline radio-container ml-0">
                                                <input type="radio"
                                                       :value="option.id"
                                                       name="Stackable"
                                                       v-model="obj_Loyalty.S"
                                                       :disabled="obj_Loyalty.I > 0"
                                                       ref="S" />
                                                <span class="col-form-label-sm">{{option.label}}</span>
                                            </div>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('S', 'MEM', 'S') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group" v-if="obj_Loyalty.LG != 3">
                                            <label class="col-form-label-sm" style="display:block">
                                                {{this.getLanguage["LPT"]["DBRA"]}}
                                                <div class="custom_tooltip">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["DBRA"]}}</span>
                                                </div>:
                                            </label>
                                            <input type="checkbox" v-model="obj_Loyalty.DBRA" :disabled="obj_Loyalty.I > 0" />
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="obj_Loyalty.LG">
                                        <CCol col="3" class="form-group" v-if="obj_Loyalty.LG == 3">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["DT"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['MEM']['DT']" size="sm" :value="ThousandSeparator(obj_Loyalty.DT, 0)" @change="v => obj_Loyalty.DT = RemoveThousandSeparator(v, 0)" ref="DT"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('DT','MEM','DT') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group" v-if="obj_Loyalty.LG > 0 && !DisplayLevelLoyalty()">
                                            <label class="col-form-label-sm">{{ this.str_conditionAmountLabel }} ({{ getLanguage['PM']['MIN'] }}) :</label>
                                            <CInput :placeholder="getLanguage['PM']['MIN']" size="sm" :value="ThousandSeparator(obj_Loyalty.MINCA, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINCA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MINCA" :prepend="currencySymbol"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MINCA', 'PM', 'MINA') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1"><label class="col-form-label-sm" style="display:block">&nbsp;</label>1</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <label class="col-form-label-sm">{{ this.str_conditionAmountLabel }} ({{ getLanguage['PM']['MIN'] }}) :</label>
                                                    <CInput :placeholder="getLanguage['PM']['MIN']" size="sm" :value="ThousandSeparator(obj_Loyalty.MINCA, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINCA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MINCA" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MINCA', 'PM', 'MINA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">({{ getLanguage['PM']['MAX'] }})<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['PM']['MAX']" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXCA, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXCA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MAXCA" :prepend="currencySymbol"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MAXCA', 'PM', 'MAXA') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1">2</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <CInput :placeholder="getLanguage['PM']['MIN'] + ' 2'" size="sm" :value="ThousandSeparator(obj_Loyalty.MINCA2, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINCA2 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MINCA2" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MINCA2', 'PM', 'MINA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <CInput :placeholder="getLanguage['PM']['MAX'] + ' 2'" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXCA2, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXCA2 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MAXCA2" :prepend="currencySymbol"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MAXCA2', 'PM', 'MAXA') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1">3</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <CInput :placeholder="getLanguage['PM']['MIN'] + ' 3'" size="sm" :value="ThousandSeparator(obj_Loyalty.MINCA3, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINCA3 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MINCA3" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MINCA3', 'PM', 'MINA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <CInput :placeholder="getLanguage['PM']['MAX'] + ' 3'" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXCA3, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXCA3 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MAXCA3" :prepend="currencySymbol"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MAXCA3', 'PM', 'MAXA') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1">4</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <CInput :placeholder="getLanguage['PM']['MIN'] + ' 4'" size="sm" :value="ThousandSeparator(obj_Loyalty.MINCA4, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINCA4 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MINCA4" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MINCA4', 'PM', 'MINA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <CInput :placeholder="getLanguage['PM']['MAX'] + ' 4'" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXCA4, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXCA4 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MAXCA4" :prepend="currencySymbol"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('MAXCA4', 'PM', 'MAXA') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3">
                                            <label class="col-form-label-sm" style="display:block">
                                                {{this.getLanguage["LPT"]["TOP"]}}<span class="required" /> :
                                                <div class="custom_tooltip">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["MCRB"]}}</span>
                                                </div>
                                            </label>
                                            <div v-for="(option, optionIndex) in dd_typeOfPayout" :key="option.id" class="inline radio-container ml-0">
                                                <input type="radio"
                                                       :value="option.id"
                                                       name="typeOfPayout"
                                                       v-model="obj_Loyalty.TOP"
                                                       :disabled="obj_Loyalty.CDT == 4 || obj_Loyalty.I > 0"
                                                       ref="TOP" />
                                                <span class="col-form-label-sm">{{option.label}}</span>
                                            </div>
                                        </CCol>
                                        <CCol col="3">
                                            <label class="col-form-label-sm d-block">
                                                {{this.getLanguage["PM"]["AP"]}}<span class="required" /> :
                                                <div class="custom_tooltip float-right">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 campaign-name" v-html="getLanguage['HELP']['AP']"></span>
                                                </div>
                                            </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_loyaltyGroupType"
                                                        :placeholder="getLanguage['PM']['DT']"
                                                        :max-height="200"
                                                        v-model="obj_Loyalty.CDT"
                                                        ref="CDT" />
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('CDT', 'PM', 'DT') }}</span>
                                        </CCol>
                                        <CCol col="3">
                                            <label v-if="obj_Loyalty.CDT==1" class="col-form-label-sm">{{this.getLanguage["MEM"]["ED"]}} :</label>
                                            <label v-else-if="obj_Loyalty.CDT==2" class="col-form-label-sm">{{this.getLanguage["MEM"]["EW"]}} :</label>
                                            <label v-else-if="obj_Loyalty.CDT==3" class="col-form-label-sm">{{this.getLanguage["MEM"]["EM"]}} :</label>
                                            <label v-else class="col-form-label-sm">&nbsp;</label>
                                            <CInput v-if="obj_Loyalty.CDT!=4"
                                                    :placeholder="getLanguage['PM']['DW']"
                                                    size="sm"
                                                    v-model="obj_Loyalty.CDV"
                                                    ref="CDV"></CInput>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('CDV', 'PM','DW') }}</span>
                                        </CCol>
                                        <CCol col="3">
                                            <label v-if="obj_Loyalty.CDT==2 || obj_Loyalty.CDT==3" class="col-form-label-sm">{{this.getLanguage["PM"]["APO"]}} :</label>
                                            <label v-else class="col-form-label-sm">&nbsp;</label>
                                            <treeselect v-if="obj_Loyalty.CDT==2"
                                                        :multiple="false"
                                                        :clearable="false"
                                                        :options="dd_weekday"
                                                        :max-height="200"
                                                        v-model="obj_Loyalty.CDO" />
                                            <treeselect v-else-if="obj_Loyalty.CDT==3"
                                                        :multiple="false"
                                                        :clearable="false"
                                                        :options="dd_monthday"
                                                        :max-height="200"
                                                        v-model="obj_Loyalty.CDO" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>3</span>{{this.getLanguage["MEM"]["LPA"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_Loyalty.LG != 1">
                                        <CCol col="12">
                                            <label class="col-form-label-sm inline">{{this.getLanguage["PM"]["PT"]}}<span class="required" /> :</label>
                                            <div v-for="(option, optionIndex) in dd_loyaltyType" :key="option.id" class="inline radio-container">
                                                <input type="radio"
                                                       :value="option.id"
                                                       name="LoyaltyType"
                                                       @change="LoyaltyTypeChange"
                                                       v-model="obj_Loyalty.LT"
                                                       :disabled="obj_Loyalty.I > 0"
                                                       ref="LT" />
                                                <span class="col-form-label-sm">{{option.label}}</span>
                                            </div>
                                            <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('LT','PM','PT') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="!DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm" v-if="(obj_Loyalty.LT==1 || obj_Loyalty.LT==3) && obj_Loyalty.LG!=1">{{ this.str_loyaltyAmountLabel }} :</label>
                                            <label class="col-form-label-sm" v-if="(obj_Loyalty.LT==2 || obj_Loyalty.LT==3) || obj_Loyalty.LG==1">{{ this.str_loyaltyAmountMaxPH }} :</label>
                                            <CInput :placeholder="str_loyaltyAmountMinPH" size="sm" :value="ThousandSeparator(obj_Loyalty.MINBA, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINBA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="(obj_Loyalty.LT==1 || obj_Loyalty.LT==3) && obj_Loyalty.LG!=1" ref="MINBA" :prepend="currencySymbol"></CInput>
                                            <CInput :placeholder="str_loyaltyAmountMaxPH" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXBA, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXBA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="(obj_Loyalty.LT==2 || obj_Loyalty.LT==3) || obj_Loyalty.LG == 1" ref="MAXBA" :prepend="currencySymbol"></CInput>
                                            <span class="ErrMsg" v-if="(obj_Loyalty.LT==1 || obj_Loyalty.LT==3) && obj_Loyalty.LG!=1">{{ ValidationLoyaltyErrMsg('MINBA', 'PM', 'MINA') }}</span>
                                            <span class="ErrMsg" v-if="(obj_Loyalty.LT==2 || obj_Loyalty.LT==3) || obj_Loyalty.LG==1">{{ ValidationLoyaltyErrMsg('MAXBA', 'PM', 'MAXA') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm" v-if="obj_Loyalty.LT==2 && obj_Loyalty.LG!=1">{{ this.getLanguage['PM']['PR'] }}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['PM']['PR']" size="sm" :value="ThousandSeparator(obj_Loyalty.BR, 2)" @change="v => obj_Loyalty.BR = RemoveThousandSeparator(v, 2)" v-if="obj_Loyalty.LT==2 && obj_Loyalty.LG!=1" ref="BR"></CInput>
                                            <span class="ErrMsg" v-if="obj_Loyalty.LT==2 && obj_Loyalty.LG!=1">{{ ValidationLoyaltyErrMsg('BR','PM','PR') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1"><label class="col-form-label-sm" style="display:block">&nbsp;</label>1</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <label class="col-form-label-sm" v-if="(obj_Loyalty.LT==1 || obj_Loyalty.LT==3) && obj_Loyalty.LG!=1">{{ this.str_loyaltyAmountLabel }} :</label>
                                                    <label class="col-form-label-sm" v-if="(obj_Loyalty.LT==2 || obj_Loyalty.LT==3) || obj_Loyalty.LG==1">{{ this.str_loyaltyAmountMaxPH }} :</label>
                                                    <CInput :placeholder="str_loyaltyAmountMinPH" size="sm" :value="ThousandSeparator(obj_Loyalty.MINBA, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINBA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="(obj_Loyalty.LT==1 || obj_Loyalty.LT==3) && obj_Loyalty.LG!=1" ref="MINBA" :prepend="currencySymbol"></CInput>
                                                    <CInput :placeholder="str_loyaltyAmountMaxPH" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXBA, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXBA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="(obj_Loyalty.LT==2 || obj_Loyalty.LT==3) || obj_Loyalty.LG == 1" ref="MAXBA" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg" v-if="(obj_Loyalty.LT==1 || obj_Loyalty.LT==3) && obj_Loyalty.LG!=1">{{ ValidationLoyaltyErrMsg('MINBA', 'PM', 'MINA') }}</span>
                                                    <span class="ErrMsg" v-if="(obj_Loyalty.LT==2 || obj_Loyalty.LT==3) || obj_Loyalty.LG==1">{{ ValidationLoyaltyErrMsg('MAXBA', 'PM', 'MAXA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm" v-if="obj_Loyalty.LT==2 && obj_Loyalty.LG!=1">{{ this.getLanguage['PM']['PR'] }}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['PM']['PR']" size="sm" :value="ThousandSeparator(obj_Loyalty.BR, 2)" @change="v => obj_Loyalty.BR = RemoveThousandSeparator(v, 2)" v-if="obj_Loyalty.LT==2 && obj_Loyalty.LG!=1" ref="BR"></CInput>
                                            <span class="ErrMsg" v-if="obj_Loyalty.LT==2 && obj_Loyalty.LG!=1">{{ ValidationLoyaltyErrMsg('BR','PM','PR') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1">2</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <CInput :placeholder="str_loyaltyAmountMinPH + ' 2'" size="sm" :value="ThousandSeparator(obj_Loyalty.MINBA2, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINBA2 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="obj_Loyalty.LT==1 || obj_Loyalty.LT==3" ref="MINBA2" :prepend="currencySymbol"></CInput>
                                                    <CInput :placeholder="str_loyaltyAmountMaxPH + ' 2'" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXBA2, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXBA2 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="obj_Loyalty.LT==2 || obj_Loyalty.LT==3" ref="MAXBA2" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg" v-if="obj_Loyalty.LT==1 || obj_Loyalty.LT==3">{{ ValidationLoyaltyErrMsg('MINBA2', 'PM', 'MINA') }}</span>
                                                    <span class="ErrMsg" v-if="obj_Loyalty.LT==2 || obj_Loyalty.LT==3">{{ ValidationLoyaltyErrMsg('MAXBA2', 'PM', 'MAXA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <CInput :placeholder="getLanguage['PM']['PR'] + ' 2'" size="sm" :value="ThousandSeparator(obj_Loyalty.BR2, 2)" @change="v => obj_Loyalty.BR2 = RemoveThousandSeparator(v, 2)" v-if="obj_Loyalty.LT==2" ref="BR2"></CInput>
                                            <span class="ErrMsg" v-if="obj_Loyalty.LT==2">{{ ValidationLoyaltyErrMsg('BR2','PM','PR') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1">3</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <CInput :placeholder="str_loyaltyAmountMinPH + ' 3'" size="sm" :value="ThousandSeparator(obj_Loyalty.MINBA3, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINBA3 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="obj_Loyalty.LT==1 || obj_Loyalty.LT==3" ref="MINBA3" :prepend="currencySymbol"></CInput>
                                                    <CInput :placeholder="str_loyaltyAmountMaxPH + ' 3'" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXBA3, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXBA3 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="obj_Loyalty.LT==2 || obj_Loyalty.LT==3" ref="MAXBA3" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg" v-if="obj_Loyalty.LT==1 || obj_Loyalty.LT==3">{{ ValidationLoyaltyErrMsg('MINBA3', 'PM', 'MINA') }}</span>
                                                    <span class="ErrMsg" v-if="obj_Loyalty.LT==2 || obj_Loyalty.LT==3">{{ ValidationLoyaltyErrMsg('MAXBA3', 'PM', 'MAXA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <CInput :placeholder="getLanguage['PM']['PR'] + ' 3'" size="sm" :value="ThousandSeparator(obj_Loyalty.BR3, 2)" @change="v => obj_Loyalty.BR3 = RemoveThousandSeparator(v, 2)" v-if="obj_Loyalty.LT==2" ref="BR3"></CInput>
                                            <span class="ErrMsg" v-if="obj_Loyalty.LT==2">{{ ValidationLoyaltyErrMsg('BR3','PM','PR') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="DisplayLevelLoyalty()">
                                        <CCol col="3" class="form-group">
                                            <CRow>
                                                <CCol col="1" class="form-group text-center pr-1">4</CCol>
                                                <CCol col="11" class="pl-0">
                                                    <CInput :placeholder="str_loyaltyAmountMinPH + ' 4'" size="sm" :value="ThousandSeparator(obj_Loyalty.MINBA4, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MINBA4 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="obj_Loyalty.LT==1 || obj_Loyalty.LT==3" ref="MINBA4" :prepend="currencySymbol"></CInput>
                                                    <CInput :placeholder="str_loyaltyAmountMaxPH + ' 4'" size="sm" :value="ThousandSeparator(obj_Loyalty.MAXBA4, getThousandCurrency ? 3 : 2)" @change="v => obj_Loyalty.MAXBA4 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="obj_Loyalty.LT==2 || obj_Loyalty.LT==3" ref="MAXBA4" :prepend="currencySymbol"></CInput>
                                                    <span class="ErrMsg" v-if="obj_Loyalty.LT==1 || obj_Loyalty.LT==3">{{ ValidationLoyaltyErrMsg('MINBA4', 'PM', 'MINA') }}</span>
                                                    <span class="ErrMsg" v-if="obj_Loyalty.LT==2 || obj_Loyalty.LT==3">{{ ValidationLoyaltyErrMsg('MAXBA4', 'PM', 'MAXA') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <CInput :placeholder="getLanguage['PM']['PR'] + ' 4'" size="sm" :value="ThousandSeparator(obj_Loyalty.BR4, 2)" @change="v => obj_Loyalty.BR4 = RemoveThousandSeparator(v, 2)" v-if="obj_Loyalty.LT==2" ref="BR4"></CInput>
                                            <span class="ErrMsg" v-if="obj_Loyalty.LT==2">{{ ValidationLoyaltyErrMsg('BR4', 'PM','PR') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="obj_Loyalty.LG != 1 && obj_Loyalty.LG != 3 && obj_Loyalty.LG != null">
                                        <CCol col="12" v-if="this.dd_game != null && this.dd_game.length > 0">
                                            <!--<CRow>
                <CCol col="6">
                    <label class="col-form-label-sm inline inline20">{{this.getLanguage["PM"]["RP"]}} :</label>
                </CCol>
            </CRow>
            <CRow>
                <CCol col="6">
                    <CInput :placeholder="getLanguage['PM']['RP']" size="sm" class="inline inline50" v-model="obj_Loyalty.BR"></CInput>
                    <CButton color="outline-dark" size="sm" @click="updateAllRebate()" class="inline inline20">
                        {{ getLanguage["BTN"]["SA"] }}
                    </CButton>
                    <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('BR', 'PM', 'GR') }}</span>
                </CCol>
            </CRow>-->
                                            <CRow>
                                                <CCol col="12">
                                                    <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:12px">
                                                        <button :class="(selectedGPCat == item.id)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGPCat = item.id" v-for="(item, index) in dd_game" :key="index">{{renderCategoryName(item.label)}}</button>
                                                    </div>
                                                    <div class="card tab-content p-2 tempScrollbar" style="height: 300px; overflow: hidden scroll;">
                                                        <div :class="item.id == selectedGPCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'" :id="'gp0-'+catIdx" v-for="(item, catIdx) in dd_game">
                                                            <div class="row">
                                                                <div class="col-md-4 text-red">
                                                                    <div class="d-flex">
                                                                        <input type="checkbox" :id="'gpcat'+item.id" class="inline custom-checkbox" @click="selectAll(catIdx)" v-model="bln_checkedAll[catIdx]" />
                                                                        <label :for="'gpcat'+item.id" class="col-form-label-sm font-weight-bold ml-2">{{getLanguage["GL"]["ALL2"]}} </label>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-4" v-for="gp in item.children">
                                                                    <div class="" style="gap: 5px; gap: 5px; display: grid !important;grid-template-columns: .2fr 3fr 2fr .5fr;">
                                                                        <input type="checkbox" :id="'gp'+gp.id" class="inline custom-checkbox" v-model="obj_Loyalty.GameIds" :value="gp.id" />
                                                                        <label :for="'gp'+gp.id" class="col-form-label-sm font-weight-bold">{{renderProviderName(gp.label)}} </label>

                                                                        <!-- <CInput size="sm" class="inline " v-model="gp.rebate" placeholder="0.00" :ref="'dd_game_' + gp.id" :disabled="toggleRebateInput(gp.id)"></CInput>
                                        <label class="col-form-label-sm font-weight-bold" style='color: #3c4b64; font-size: smaller; font-weight: 600;'>%</label> -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CCol>
                                            </CRow>
                                        </CCol>

                                        <br />
                                    </CRow>
                                    <CRow v-if="obj_Loyalty.LG == 1">
                                        <CCol col="12" v-if="this.dd_game != null && this.dd_game.length > 0">
                                            <CRow>
                                                <CCol col="6">
                                                    <label class="col-form-label-sm inline inline20">{{this.getLanguage["PM"]["RP"]}} :</label>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="6">
                                                    <CInput :placeholder="getLanguage['PM']['RP']" size="sm" class="inline inline50" v-model="obj_Loyalty.BR"></CInput>
                                                    <CButton color="outline-dark" size="sm" @click="updateAllRebate()" class="inline inline20">
                                                        {{ getLanguage["BTN"]["SA"] }}
                                                    </CButton>
                                                    <span class="ErrMsg">{{ ValidationLoyaltyErrMsg('BR', 'PM', 'GR') }}</span>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="12">
                                                    <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:12px">
                                                        <button :class="(selectedGPCat == item.id)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGPCat = item.id" v-for="(item, index) in dd_game" :key="index">{{renderCategoryName(item.label)}}</button>
                                                    </div>
                                                    <div class="card tab-content p-2 tempScrollbar" style="height: 300px; overflow: hidden scroll;">
                                                        <div :class="item.id == selectedGPCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'" :id="'gp0-'+catIdx" v-for="(item, catIdx) in dd_game">
                                                            <div class="row">
                                                                <div class="col-md-4 text-red">
                                                                    <div class="d-flex">
                                                                        <input type="checkbox" :id="'gpcat'+item.id" class="inline custom-checkbox" @click="selectAll(catIdx)" v-model="bln_checkedAll[catIdx]" />
                                                                        <label :for="'gpcat'+item.id" class="col-form-label-sm font-weight-bold ml-2">{{getLanguage["GL"]["ALL2"]}} </label>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-4" v-for="gp in item.children">
                                                                    <div class="" style="gap: 5px; gap: 5px; display: grid !important;grid-template-columns: .2fr 3fr 2fr .5fr;">
                                                                        <input type="checkbox" :id="'gp'+gp.id" class="inline custom-checkbox" v-model="obj_Loyalty.GameIds" :value="gp.id" />
                                                                        <label :for="'gp'+gp.id" class="col-form-label-sm font-weight-bold">{{renderProviderName(gp.label)}} </label>

                                                                        <CInput size="sm" class="inline " v-model="gp.rebate" placeholder="0.00" :ref="'dd_game_' + gp.id" :disabled="toggleRebateInput(gp.id)"></CInput>
                                                                        <label class="col-form-label-sm font-weight-bold" style='color: #3c4b64; font-size: smaller; font-weight: 600;'>%</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CCol>
                                            </CRow>


                                        </CCol>
                                    </CRow>
                                    <!-- RANKING STRART -->
                                    <br v-if="obj_Loyalty.RBGame != null && obj_Loyalty.RBGame.length!=0">
                                    <label class="col-form-label-sm full-width"
                                           v-if="obj_Loyalty.RBGame && obj_Loyalty.RBGame.length"
                                           style="font-size:15px;font-weight:bold;">
                                        <div class="d-inline-flex align-items-center">
                                            {{this.getLanguage['MR']['ARLP']}} :
                                            <div class="custom_tooltip float-right ml-1">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2 campaign-name" v-html="this.getLanguage['HELP']['ARLP']"></span>
                                            </div>
                                        </div>
                                    </label>
                                    <div class="custom-table-wrapper" style=" overflow: auto hidden;">
                                        <table class='custom-table afb-blue' v-if="obj_Loyalty.RBGame != null && obj_Loyalty.RBGame.length!=0">
                                            <thead>
                                                <tr>
                                                    <th> {{this.getLanguage['DB']['CN']}} </th>
                                                    <th v-for="rank in ranks" :key="rank" style="width:250px;">
                                                        <div class="d-flex">
                                                            <div class="w-50">
                                                                {{getLanguage['MEM']['R']}} {{ rank }} (%)
                                                            </div>
                                                            <div class="w-50">
                                                                {{getLanguage['PM']['MAX']}}  {{getLanguage['PM']['AC21']}}
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="arry_cateogry != null && arry_cateogry.length>1">
                                                    <td>{{this.getLanguage['ACU']['QA']}}</td>
                                                    <td v-for="rank in ranks" :key="rank" style="width:250px;">
                                                        <div class="d-flex">
                                                            <div class="w-50">
                                                                <CInput :placeholder="getLanguage['PM']['PR']" size="sm" class="inline" :value="ThousandSeparator(0.00, 2)" @change="QuickUpdateAddOnRebate( rank,'AOBV',$event)"></CInput>
                                                            </div>
                                                            <div class="w-50">
                                                                <CInput :placeholder="getLanguage['PM']['PR']" size="sm" class="inline" :value="ThousandSeparator(0.00, 2)" @change="QuickUpdateAddOnRebate( rank,'AOMP',$event)"></CInput>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-for="category in arry_cateogry" :key="category.GCI">
                                                    <td>{{renderCategoryName(category.CN)}}</td>
                                                    <td v-for="rank in ranks" :key="rank" style="width:250px;">
                                                        <div class="d-flex">
                                                            <div class="w-50">
                                                                <CInput :placeholder="getLanguage['PM']['PR']" size="sm" class="inline" :value="ThousandSeparator(getBonusValue(category.GCI, rank), 2)" @change="RankingAddOnRebate(category.GCI, rank,'AOBV',$event)"></CInput>
                                                            </div>
                                                            <div class="w-50">
                                                                <CInput :placeholder="getLanguage['PM']['PR']" size="sm" class="inline" :value="ThousandSeparator(getMaxBonusValue(category.GCI, rank), 2)" @change="RankingAddOnRebate(category.GCI, rank,'AOMP',$event)"></CInput>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <!-- <td v-for="rankingData in obj_Loyalty.RBGame" :key="rankingData.R">
                        <input :value="getBonusValue(rankingData, category.GCI)" type="number" />
                    </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- RANKING END -->
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveLoyalty()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </CRow>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["RS"]}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["AGI"] }}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'LPN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["LPN"] }} / {{ getLanguage["PM"]["PT"] }} / {{ getLanguage["MEM"]["CI"] }}
                                                <i @click="setSortTable('LN')" :class="setSortLogo('LN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'S'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["S"] }}
                                                <i @click="setSortTable('S')" :class="setSortLogo('S')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TOP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["LPT"]["TOP"] }}
                                                <i @click="setSortTable('TOP')" :class="setSortLogo('TOP')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'LPT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["LPT"] }} / {{ getLanguage["PM"]["CA"] }} / {{ getLanguage["MEM"]["DT"] }}
                                                <i @click="setSortTable('LG')" :class="setSortLogo('LG')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["PA"] }}
                                                <i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["AG"]["GP"] }}
                                            </template>
                                            <template v-else-if="header == 'MAX'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["MAX"] }} {{ getLanguage["PM"]["AC21"] }}
                                                <i @click="setSortTable('MAXBA')" :class="setSortLogo('MAXBA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'SD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["SD"]}}
                                                <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                                <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                            </template>
                                            <template v-else-if="header == 'UB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["UB"]}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["LYT"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addLoyalty()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div v-if="!isSubAgent" class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["LPN"]}} :</span>
                                <CInput size="sm" :value="arr_FV['LN']" @change="v => arr_FV['LN'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["LPT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_loyaltyGroup"
                                            :placeholder="this.utilGetDDLanguage('MEM.LPT')"
                                            v-model="arr_FV['LG']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["PT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_loyaltyType"
                                            :placeholder="this.utilGetDDLanguage('PM.PT')"
                                            v-model="arr_FV['LT']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CI']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['MEM']['LL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RS"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LPN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["LPN"] }} / {{ getLanguage["PM"]["PT"] }} / {{ getLanguage["MEM"]["CI"] }}
                                        <i @click="setSortTable('LN')" :class="setSortLogo('LN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'S'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["S"] }}
                                        <i @click="setSortTable('S')" :class="setSortLogo('S')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TOP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["LPT"]["TOP"] }}
                                        <i @click="setSortTable('TOP')" :class="setSortLogo('TOP')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["LPT"] }} / {{ getLanguage["PM"]["CA"] }} / {{ getLanguage["MEM"]["DT"] }}
                                        <i @click="setSortTable('LG')" :class="setSortLogo('LG')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PA"] }}
                                        <i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["AG"]["GP"] }}
                                    </template>
                                    <template v-else-if="header == 'MAX'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["MAX"] }} {{ getLanguage["PM"]["AC21"] }}
                                        <i @click="setSortTable('MAXBA')" :class="setSortLogo('MAXBA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["SD"]}}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["UB"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RS"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LPN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["LPN"] }} / {{ getLanguage["PM"]["PT"] }} / {{ getLanguage["MEM"]["CI"] }}
                                        <i @click="setSortTable('LN')" :class="setSortLogo('LN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'S'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["S"] }}
                                        <i @click="setSortTable('S')" :class="setSortLogo('S')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TOP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["LPT"]["TOP"] }}
                                        <i @click="setSortTable('TOP')" :class="setSortLogo('TOP')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'LPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["LPT"] }} / {{ getLanguage["PM"]["CA"] }} / {{ getLanguage["MEM"]["DT"] }}
                                        <i @click="setSortTable('LG')" :class="setSortLogo('LG')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PA"] }}
                                        <i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["AG"]["GP"] }}
                                    </template>
                                    <template v-else-if="header == 'MAX'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["MAX"] }} {{ getLanguage["PM"]["AC21"] }}
                                        <i @click="setSortTable('MAXBA')" :class="setSortLogo('MAXBA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["SD"]}}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["UB"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Loyalty.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Loyalty">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                    <span id="actionBtnCol">
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="cil-trash" @click='removeLoyalty(data)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="cil-trash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="cil-color-border" @click='editLoyalty(data.I)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="cil-color-border"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add))">
                                    <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <CCol col="4">
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="data.RS" @click="updateStatus(data)">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </span>
                                    <span v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <CCol col="4">
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="data.RS">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </span>
                                </template>
                                <template v-else-if="header == 'BN'">
                                    {{ data.GN }} ({{ data.GPC }})
                                </template>
                                <template v-else-if="header == 'LPN'">
                                    <span class="grid-line bold">{{ data.LN }}</span>
                                    <span class="grid-line">{{ renderLoyaltyType(data.LT, data.LG) }}</span>
                                    <span class="grid-line">{{ data.ISOC }}</span>
                                </template>
                                <template v-else-if="header == 'S'">
                                    <span class="grid-line">{{ renderLoyaltyStackable(data.S) }}</span>
                                </template>
                                <template v-else-if="header == 'TOP'">
                                    <span class="grid-line">{{ renderTypeOfPayout(data.TOP) }}</span>
                                </template>
                                <template v-else-if="header == 'LPT'">
                                    <span class="grid-line">{{ renderLoyaltyGroup(data.LG) }}</span>
                                    <span class="grid-line">{{ renderConditionAmount(data.MINCA, data.MAXCA, data) }}</span>
                                    <span class="grid-line">{{ data.DT }}</span>
                                </template>
                                <template v-else-if="header == 'PA'">
                                    <span @click="DisplayBA(index)" style="max-width: 200px; display: block; white-space: break-spaces;" :class="openedBA.includes(index) ? '':'shorttext'" v-html="renderLoyaltyAmount(data.LG, data.BGame, data.LT, data.MINBA, data.MAXBA, data.BR, data)"></span>
                                </template>
                                <template v-else-if="header == 'GP'">
                                    <span @click="DisplayGP(index)" style="max-width: 200px; display: block; white-space: break-spaces;" :class="openedGP.includes(index) ? '':'shorttext'" v-html="renderLoyaltyGP(data.BGI)"></span>
                                </template>
                                <template v-else-if="header == 'MAX'">
                                    {{ formatNumber(data.MAXBA, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'SD' && data.ATS == null">
                                    -
                                </template>
                                <template v-else-if="header == 'SD'">
                                    {{ formatDateTime(data.ATS,"YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line">{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                </template>
                                <template v-else-if="header == 'UB'">
                                    {{ data.UB }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constLoyaltyGroup, constPromoType, constTurnoverType, constAutoRebateGroupType, constAutoRebateGroupTypeSA, constWeekday, constLoyaltyStackable, constTypeOfPayout } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import moment from "moment";
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, numeric, requiredIf, alphaNum, decimal, minValue } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))

    Vue.use(require('vue-moment'));

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_currencyloaded: false,
                bool_showSearchBar: true,
                openedGP: [],
                openedBA: [],
                arr_FV: {
                    "LN": "",
                    "LG": null,
                    "LT": null,
                    "AGI": null,
                    "SAGAGI": null,
                    "ST": 2,
                    "CI": null,
                    "CTS": {
                        startDate: "",
                        endDate: ""
                    },
                },
                arr_Loyalty: [],
                obj_Loyalty: {
                    "I": 0,
                    "RS": 1,
                    "AGI": "",
                    "SAGAGI": null,
                    "AGIT": null,
                    "LN": "",
                    "LG": null,
                    "LT": 2,
                    "S": 0,
                    "TOP": 0,
                    "CDT": null,
                    "CDV": "",
                    "MINCA": null,
                    "MAXCA": null,
                    "MINBA": null,
                    "MAXBA": null,
                    "BR": null,
                    "BGI": "",
                    "GameIds": [],
                    "BGame": [],

                    "MINCA2": null,
                    "MAXCA2": null,
                    "MINBA2": null,
                    "MAXBA2": null,
                    "BR2": null,

                    "MINCA3": null,
                    "MAXCA3": null,
                    "MINBA3": null,
                    "MAXBA3": null,
                    "BR3": null,

                    "MINCA4": null,
                    "MAXCA4": null,
                    "MINBA4": null,
                    "MAXBA4": null,
                    "BR4": null,

                    "CI": null,
                    "CDO": null,
                    "DT": null,
                    "MCRB": null
                },
                ranks: [1, 2, 3, 4, 5],
                arry_cateogry:[],
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_loyaltyGroup: [],
                dd_loyaltyType: [],
                dd_loyaltyStackable: [],
                dd_typeOfPayout: [],
                dd_loyaltyGroupType: [],
                dd_game: [],
                dd_loyaltyStatus: [],
                bool_gameloaded: false,
                bool_LoyaltyCV: false,
                str_conditionAmountLabel: "",
                str_loyaltyAmountLabel: "",
                str_loyaltyAmountMinPH: "",
                str_loyaltyAmountMaxPH: "",
                int_oldBonusGroup: null,
                bool_gameRebateMissing: false,
                dd_weekday: [],
                dd_monthday: [],
                dd_currency: [],
                dd_currency2: [],
                constAccessType: constAccessType,
                gameProviderList: [],
                bln_checkedAll: [],
                isSubAgent: false,
                defaultReportHeaders: ['NO', 'ACT', 'RS', 'BN', 'LPN', 'S', 'TOP', 'LPT', 'PA', 'GP', 'MAX', 'SD', 'CTS', 'UB'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                selectedGPCat: "",
                old_TOP: null,
                currencySymbol: ''
            }
        },
        validations: {
            obj_Loyalty: {
                "LN": { required },
                "AGI": { required },
                "LG": { required },
                "CDT": { required },
                "CDV": {
                    required: requiredIf(function (vm) {
                        return vm.CDT != 4;
                    })
                },
                "CI": { required },
                "MINCA": { decimal, minValueValue: minValue(0) },
                "MAXCA": { decimal },
                "LT": { required },
                "S": { required },
                "MINBA": {
                    required: requiredIf(function (vm) {
                        return (vm.LT == 1 || vm.LT == 3) && vm.LG != 1;
                    }), decimal
                },
                "MAXBA": {
                    required: requiredIf(function (vm) {
                        return vm.LT == 2;
                    }), decimal, minValueValue: minValue(0)
                },
                "BR": {
                    required: requiredIf(function (vm) {
                        return vm.LT == 2 && vm.LG != 1;
                    }), decimal
                },

                "MINCA2": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) &&
                            (vm.MAXCA2 > 0 || vm.MINBA2 > 0 || vm.MAXBA2 > 0 || vm.BR2 > 0);
                    }), decimal
                },
                "MAXCA2": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) &&
                            (vm.MINCA2 > 0 || vm.MINBA2 > 0 || vm.MAXBA2 > 0 || vm.BR2 > 0);
                    }), decimal
                },
                "MINBA2": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 1 &&
                            (vm.MAXCA2 > 0 || vm.MINCA2 > 0);
                    }), decimal
                },
                "MAXBA2": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 2 &&
                            (vm.MAXCA2 > 0 || vm.MINCA2 > 0 || vm.BR2 > 0);
                    }), decimal
                },
                "BR2": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 2 &&
                            (vm.MINCA2 > 0 || vm.MAXCA2 > 0 || vm.MINBA2 > 0 || vm.MAXBA2 > 0);
                    }), decimal
                },


                "MINCA3": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) &&
                            (vm.MAXCA3 > 0 || vm.MINBA3 > 0 || vm.MAXBA3 > 0 || vm.BR3 > 0);
                    }), decimal
                },
                "MAXCA3": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) &&
                            (vm.MINCA3 > 0 || vm.MINBA3 > 0 || vm.MAXBA3 > 0 || vm.BR3 > 0);
                    }), decimal
                },
                "MINBA3": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 1 &&
                            (vm.MAXCA3 > 0 || vm.MINCA3 > 0);
                    }), decimal
                },
                "MAXBA3": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 2 &&
                            (vm.MAXCA3 > 0 || vm.MINCA3 > 0 || vm.BR3 > 0);
                    }), decimal
                },
                "BR3": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 2 &&
                            (vm.MINCA3 > 0 || vm.MAXCA3 > 0 || vm.MINBA3 > 0 || vm.MAXBA3 > 0);
                    }), decimal
                },


                "MINCA4": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) &&
                            (vm.MAXCA4 > 0 || vm.MINBA4 > 0 || vm.MAXBA4 > 0 || vm.BR4 > 0);
                    }), decimal
                },
                "MAXCA4": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) &&
                            (vm.MINCA4 > 0 || vm.MINBA4 > 0 || vm.MAXBA4 > 0 || vm.BR4 > 0);
                    }), decimal
                },
                "MINBA4": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 1 &&
                            (vm.MAXCA4 > 0 || vm.MINCA4 > 0);
                    }), decimal
                },
                "MAXBA4": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 2 &&
                            (vm.MAXCA4 > 0 || vm.MINCA4 > 0 || vm.BR4 > 0);
                    }), decimal
                },
                "BR4": {
                    required: requiredIf(function (vm) {
                        return (vm.LG == 11 || vm.LG == 12) && vm.LT == 2 &&
                            (vm.MINCA4 > 0 || vm.MAXCA4 > 0 || vm.MINBA4 > 0 || vm.MAXBA4 > 0);
                    }), decimal
                },
                "DT": {
                    required: requiredIf(function (vm) {
                        return vm.LG == 3;
                    }), numeric
                },
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_LoyaltyCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getDropdownList();
                this.getLoyaltyList();
            },
            'obj_Loyalty.CDT': function (newVal, oldVal) {
                if (newVal == 4)
                    this.obj_Loyalty.TOP = 0;
                else if (this.old_TOP)
                    this.obj_Loyalty.TOP = this.old_TOP;
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/Loyalty`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.delete))) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')
                                }
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.add))) {
                                    that.removeDefaultColumn('RS')
                                    that.removeColumn('RS')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/Loyalty/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.CTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.CTS.endDate = "";
                    }
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('LYT', 'P', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_LoyaltyCV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getLoyaltyList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getLoyaltyList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getLoyaltyList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            CurrencyChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.currencySymbol = val.label;
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                        }
                    });
                }
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getDropdownList() {
                var that = this;

                this.dd_loyaltyGroup = [{
                    id: 1,
                    label: this.getLanguage["PM"]["TURNO"]
                }, {
                    id: 11,
                    label: this.getLanguage["PM"]["TURNOL"]
                }, {
                    id: 2,
                    label: this.getLanguage["PM"]["WINL"]
                }, {
                    id: 12,
                    label: this.getLanguage["PM"]["WINLL"]
                }, {
                    id: 3,
                    label: this.getLanguage["SMB"]["D"]
                }];
                this.dd_loyaltyType = [{
                    id: 1,
                    label: this.getLanguage["PM"]["FA"]
                }, {
                    id: 2,
                    label: this.getLanguage["PM"]["P"]
                }
                ];
                this.dd_loyaltyStackable = constLoyaltyStackable;
                this.dd_typeOfPayout = [{
                    id: 0,
                    label: this.getLanguage["MTA"]["0"]
                }, {
                    id: 1,
                    label: this.getLanguage["MTA"]["1"]
                }];
                this.dd_turnoverType = constTurnoverType;
                this.dd_loyaltyGroupType = [{
                    id: 1,
                    label: this.getLanguage["PM"]["DY"]
                }, {
                    id: 2,
                    label: this.getLanguage["PM"]["WK"]
                }, {
                    id: 3,
                    label: this.getLanguage["PM"]["MH"]
                }
                ];

                if (this.getUserInfo.AT == 0 || this.checkModuleAccess('AIAR', 'P', constAccessType.add) || this.checkModuleAccess('AIAR', 'P', constAccessType.edit)) {
                    this.dd_loyaltyGroupType = [
                    {
                        id: 4,
                        label: this.getLanguage["PM"]["INS"]
                    }, {
                        id: 1,
                        label: this.getLanguage["PM"]["DY"]
                    }, {
                        id: 2,
                        label: this.getLanguage["PM"]["WK"]
                    }, {
                        id: 3,
                        label: this.getLanguage["PM"]["MH"]
                    }
                    ];
                }

                this.dd_weekday = constWeekday;
                this.dd_loyaltyStatus = [{
                    id: "2",
                    label: this.getLanguage["GL"]["AC"]
                }, {
                    id: "1",
                    label: this.getLanguage["GL"]["IAC"] + " / " + this.getLanguage["PM"]["PAST"]
                }];

                // this.dd_weekday.unshift({
                //     id: 0,
                //     label: this.getLanguage["PM"]["PJD"]
                // }); //comment on 29/11/2021 TT2258

                this.dd_monthday = [];

                //  this.dd_monthday.push({
                //      id: 0,
                //      label: this.getLanguage["PM"]["PJD"]
                //  }); //comment on 29/11/2021 TT2258

                for (var i = 1; i <= 28; i++) {
                    this.dd_monthday.push({
                        id: i,
                        label: i
                    });
                }

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            renderLoyaltyGroup(int_loyaltyGroup) {
                var loyaltyGroup = "";
                for (var i = 0; i < this.dd_loyaltyGroup.length; i++) {
                    if (this.dd_loyaltyGroup[i].id == int_loyaltyGroup) {
                        loyaltyGroup = this.dd_loyaltyGroup[i].label;
                        break;
                    }
                }
                return loyaltyGroup;
            },
            renderConditionAmount(dec_minConditionAmount, dec_maxCondtionAmount, data) {
                if (dec_maxCondtionAmount > 0) {
                    return this.formatNumber(dec_minConditionAmount, 2, data.CS) +
                        " - " +
                        this.formatNumber(dec_maxCondtionAmount, 2, data.CS);
                } else if (dec_minConditionAmount > 0) {
                    return this.formatNumber(dec_minConditionAmount, 2, data.CS)
                }
                else {
                    return "-";
                }
            },
            renderLoyaltyType(int_loyaltyType, int_loyaltyGroup) {
                if (int_loyaltyGroup != 1) {
                    for (var i = 0; i < constPromoType.length; i++) {
                        if (constPromoType[i].id == int_loyaltyType)
                            return constPromoType[i].label;
                    }
                }

                return "-";

            },
            renderLoyaltyStackable(int_stackable) {
                var stackable = "";
                for (var i = 0; i < constLoyaltyStackable.length; i++) {
                    if (constLoyaltyStackable[i].id == int_stackable)
                        stackable = constLoyaltyStackable[i].label;
                }
                return stackable;
            },
            renderTypeOfPayout(id) {
                const AutoManual = [{
                    id: 0,
                    label: this.getLanguage["MTA"]["0"]
                }, {
                    id: 1,
                    label: this.getLanguage["MTA"]["1"]
                }];
                var label = "";
                for (var i = 0; i < AutoManual.length; i++) {
                    if (AutoManual[i].id == id)
                        label = AutoManual[i].label;
                }
                return label;
            },
            renderLoyaltyAmount(int_loyaltyGroup, list_BonusGame, int_loyaltyType, dec_loyaltyMinAmount, dec_loyaltyMaxAmount, dec_bonusRatio, data) {
                if (int_loyaltyGroup != 1) {
                    if (int_loyaltyType == 1) {
                        return this.formatNumber(dec_loyaltyMinAmount, 2, data.CS);
                    }
                    else if (int_loyaltyType == 2) {
                        var loyalty = dec_bonusRatio.toFixed(2) + "%";

                        if (dec_loyaltyMinAmount > 0 && dec_loyaltyMaxAmount > 0) {
                            loyalty +=
                                "<span class='grid-line'>" +
                                this.formatNumber(dec_loyaltyMinAmount, 2, data.CS) +
                                " - " +
                                this.formatNumber(dec_loyaltyMaxAmount, 2, data.CS) +
                                "</span>";
                        }

                        return loyalty;
                    }
                    else {
                        return dec_loyaltyMinAmount + " * " + this.formatNumber(dec_loyaltyMaxAmount, DecimalS, ThousandS, decimalPoint, CurSym);
                    }
                }
                else {
                    var gameList = "";
                    if (list_BonusGame != null && list_BonusGame.length > 0) {
                        for (var i = 0; i < list_BonusGame.length; i++) {
                            if (i > 0) {
                                gameList += " / ";
                            }
                            gameList += this.renderProviderName(list_BonusGame[i].GN) + " (" + list_BonusGame[i].BV + "%)";
                        }
                    }
                    return gameList;
                }
            },

            renderLoyaltyGP(list_BonusGame) {
                var result = "";
                try {
                    if (list_BonusGame != null && list_BonusGame != "") {
                        var gameList = list_BonusGame.split(",");                        
                        for (var i = 0; i < gameList.length; i++) {
                            try {                                
                                var GPro = this.gameProviderList.find(o => o.id === gameList[i].split("-")[1]);                                
                                if (GPro) {
                                    result += this.renderProviderName(GPro.label);

                                    if (i + 1 < gameList.length) {
                                        result += " / ";
                                    }
                                }                                                                                                                                                                                              
                            }
                            catch (ex) {
                                result += "/ Disabled Provider "
                                console.log(ex);
                            }
                        }
                    }
                    else {
                        result = this.getLanguage['GL']['ALL']
                    }
                }
                catch (err) {
                    result = "Provider Temporary Unavailable";
                    console.log(err);
                }
                return result;
            },
            DisplayGP(index) {
                if (this.openedGP.includes(index)) {
                    this.openedGP.splice(this.openedGP.indexOf(index), 1);
                } else {
                    this.openedGP.push(index);
                }
            },
            DisplayBA(index) {
                if (this.openedBA.includes(index)) {
                    this.openedBA.splice(this.openedBA.indexOf(index), 1);
                } else {
                    this.openedBA.push(index);
                }
            },
            getGameProviderList() {
                var that = this;
                this.getDataApi(`/api/dd/gameProv`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }

                            that.gameProviderList = d.dropdownlist;
                        }
                        else {
                            that.gameProviderList = null;
                        }

                    });
            },
            getLoyaltyList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.LN=" + (this.arr_FV["LN"] == null ? "" : this.arr_FV["LN"]) +
                        "&f.LG=" + (this.arr_FV["LG"] == null ? "" : this.arr_FV["LG"]) +
                        "&f.LT=" + (this.arr_FV["LT"] == null ? "" : this.arr_FV["LT"]) +
                        "&f.ST=" + (this.arr_FV["ST"] == null ? "" : this.arr_FV["ST"]) +
                        "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]));
                    //"&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]));

                    if (this.arr_FV.CTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.CTS.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.CTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.CTS.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }
                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : "4-" + this.arr_FV["SAGAGI"])
                    } else {
                        path += "&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]);
                    }
                }

                this.getDataApi(`/api/mloyalty/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_Loyalty = d.D.Items;
                            that.isSubAgent = d.D.Items[0].ISA;
                            that.resizeTableHead();                            
                        }
                    });

            },
            AgentGroupChange(value) {
                this.obj_Loyalty.SAGAGI = null;
                this.RenderAgentGroupChange(value, true, this.populateGameIds);
            },
            RenderAgentGroupChange(value, isReset, gameCallback = null) {
                var that = this;
                this.bool_gameloaded = false;
                this.bool_currencyloaded = false;

                var agi = 0;
                if (value) {
                    agi = value.split("-")[1];
                    this.getDataApi('/api/dd/game/provexcludecategory/' + agi + '/6',
                        function (d, s) {
                            if (s) {
                                that.bool_gameloaded = true;
                                that.dd_game = d.dropdownlist;
                                that.selectedGPCat = that.dd_game[0].id;

                                that.$set(that.$data, 'dd_game', d.dropdownlist);

                                if (isReset) {
                                    that.obj_Loyalty.GameIds = [];
                                    that.obj_Loyalty.BGI = "";
                                }

                                if (gameCallback != null) {
                                    gameCallback(!isReset);
                                }

                                that.checkSelectAllButton();
                                that.genarateRBGame(agi);
                            }
                        });

                    this.getDataApi('/api/dd/cur/' + agi,
                        function (d, s) {
                            if (s) {
                                that.bool_currencyloaded = true;
                                that.dd_currency2 = d.dropdownlist;
                                if (that.obj_Loyalty.I > 0) {
                                    that.CurrencyChange(that.obj_Loyalty.CI);
                                } 
                                if (isReset)
                                    that.obj_Loyalty.CI = null;

                                if (that.dd_currency2.length == 1) {
                                    that.obj_Loyalty.CI = that.dd_currency2[0].id;
                                    that.CurrencyChange(that.dd_currency2[0].id);
                                }
                            }
                        });
                }
            },
            genarateRBGame(agi){
                var passInLG =this.obj_Loyalty.LG==null ? 0:this.obj_Loyalty.LG;
                var that = this;
                this.getDataApi('/api/mloyalty/getrank/' + agi +'/'+ that.obj_Loyalty.I+'/'+ passInLG,
                    function (d, s) {
                        if (s) {
                            that.obj_Loyalty.RBGame=d;
                            that.ranks = d.map(game => game.R);
                            that.ranks = [...new Set(that.ranks)];

                            // 排序
                            that.ranks.sort((a, b) => a - b);  // 按照数字升序排序

                             if(passInLG != 1){
                                that.arry_cateogry = d.reduce((result, item) => {
                                const existingGroup = result.find(group => group.GCI == item.GCI );

                                if (existingGroup) {
                                    
                                } else {
                                
                                    result.push({
                                        GCI: item.GCI,
                                        CN: item.CN,
                                    });
                                }

                                return result;
                                }, []);
                            }
                            else{
                                that.arry_cateogry = that.dd_game .reduce((result, item) => {
                                const existingGroup = result.find(group => group.GCI == item.id );
                                if (existingGroup) {
                                    
                                } else {
                                
                                    result.push({
                                        GCI: item.id,
                                        CN: item.label,
                                    });
                                }

                                return result;
                                }, []);

                            }

                            // if (passInLG !== 1) {
                            //     that.arry_cateogry = Array.from(new Set(d.map(item => ({ GCI: item.GCI, CN: item.CN }))));
                            // } else {
                            //     that.arry_cateogry = Array.from(new Set(that.dd_game.map(item => ({ GCI: item.id, CN: item.label }))));
                            // }
                            that.$forceUpdate();

                        }
                    });
            },
            getBonusValue(GCI, rank) {
                const matchingRow = this.obj_Loyalty.RBGame.find(
                    (row) => row.GCI == GCI && row.R == rank
                );
                return matchingRow ? matchingRow.AOBV : 0;
            },
            getMaxBonusValue(GCI, rank) {
                const matchingRow = this.obj_Loyalty.RBGame.find(
                    (row) => row.GCI == GCI && row.R == rank
                );
                return matchingRow ? matchingRow.AOMP : 0;
            },
            RankingAddOnRebate(GCI, rank, type, event) {
                const newValue = parseFloat(event);

                // 在 obj_Loyalty.RBGame 中找到匹配的项，并更新 AddOnBonusValue
                //1 obj
                const matchingRow = this.obj_Loyalty.RBGame.find(
                    (row) => row.GCI == GCI && row.R == rank
                );

                if (matchingRow && type=="AOBV") {
                    matchingRow.AOBV = newValue;
                }
                else if(matchingRow && type=="AOMP"){
                    matchingRow.AOMP = newValue;
                }
                 else {
                    // 如果找不到匹配的项，可能需要创建新的数据项
                    this.obj_Loyalty.RBGame.push({
                    GCI: GCI,
                    R: rank,
                    AOBV: newValue,
                    });
                }
            },
            QuickUpdateAddOnRebate( rank,type, event) {
                const newValue = parseFloat(event);

                // update all AddOnBonusValue on obj_Loyalty.RBGame
                this.obj_Loyalty.RBGame.forEach((row) => {
                    if (row.R == rank && type=="AOBV") {
                        row.AOBV = newValue;
                    }
                    else if(row.R == rank &&type=="AOMP"){
                        row.AOMP = newValue;
                    }
                });
                this.$forceUpdate();
            },
            
            
            RenderSubAgentGroupChange(value, isReset, gameCallback = null) {
                var that = this;
                this.bool_gameloaded = false;
                this.bool_currencyloaded = false;

                var agi = 0;

                if (value) {
                    agi = value;
                    this.getDataApi('/api/dd/game/provexcludecategory/' + agi + '/6',
                        function (d, s) {
                            if (s) {
                                that.bool_gameloaded = true;
                                that.dd_game = d.dropdownlist;
                                that.selectedGPCat = that.dd_game[0].id;

                                that.$set(that.$data, 'dd_game', d.dropdownlist);

                                if (isReset) {
                                    that.obj_Loyalty.GameIds = [];
                                    that.obj_Loyalty.BGI = "";
                                }

                                if (gameCallback != null) {
                                    gameCallback(!isReset);
                                }

                                that.checkSelectAllButton();
                            }
                        });

                    this.getDataApi('/api/dd/cur/' + agi,
                        function (d, s) {
                            if (s) {
                                that.bool_currencyloaded = true;
                                that.dd_currency2 = d.dropdownlist;
                                if (that.obj_Loyalty.I > 0) {
                                    that.CurrencyChange(that.obj_Loyalty.CI);
                                }
                                if (isReset)
                                    that.obj_Loyalty.CI = null;
                            }
                        });
                }
                
            },
            AgentGroupChangefs(value) {
                this.arr_FV['SAGAGI'] = null;
                var agi = 0;

                if (value != undefined) {
                    if (value != "") {
                        this.arr_FV["AGI"] = value;
                        agi = this.arr_FV["AGI"].split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            ValidationLoyaltyErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_LoyaltyCV) {
                    if (langKey1 == "") {
                        langKey1 = "PM";
                    }

                    if (langKey2 == "") {
                        langKey2 = value;
                    }

                    if (value == "GR") {
                        if (this.bool_gameRebateMissing) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "CDT") {
                        if (this.obj_Loyalty.CDT == 0)
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }

                    if (value == "CDV") {
                        if (!this.obj_Loyalty.CDV && this.obj_Loyalty.CDT != 4)
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        else if (isNaN(this.obj_Loyalty.CDV) && this.obj_Loyalty.CDT != 4)
                            return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                        else if (this.obj_Loyalty.CDV < 0 && this.obj_Loyalty.CDT != 4)
                            return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[langKey1][langKey2]);
                    }

                    if (value == "DT") {
                        if (this.obj_Loyalty.LG == 3 && this.obj_Loyalty.DT == 0)
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }

                    if (value == "MINBA") {
                        if (this.obj_Loyalty.LT == 1 && this.obj_Loyalty.MINBA == 0 && this.obj_Loyalty.LG != 1)
                            return String.format(this.utilGetErrorLanguage('1001'), this.str_loyaltyAmountMinPH);
                    }

                    if (value == "BR") {
                        if (this.obj_Loyalty.LT == 2 && this.obj_Loyalty.BR == 0 && this.obj_Loyalty.LG != 1)
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }

                    if (value == "BR2") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (this.obj_Loyalty.BR2 == 0 && (this.obj_Loyalty.MINCA2 > 0 || this.obj_Loyalty.MAXCA2 > 0 || this.obj_Loyalty.MAXBA2 > 0))
                                return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "BR3") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (this.obj_Loyalty.BR3 == 0 && (this.obj_Loyalty.MINCA3 > 0 || this.obj_Loyalty.MAXCA3 > 0 || this.obj_Loyalty.MAXBA3 > 0))
                                return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "BR4") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (this.obj_Loyalty.BR4 == 0 && (this.obj_Loyalty.MINCA4 > 0 || this.obj_Loyalty.MAXCA4 > 0 || this.obj_Loyalty.MAXBA4 > 0))
                                return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "MAXCA") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (Number(this.obj_Loyalty.MAXCA) < Number(this.obj_Loyalty.MINCA))
                                return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "MINCA2") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (Number(this.obj_Loyalty.MINCA2) <= Number(this.obj_Loyalty.MAXCA) && (this.obj_Loyalty.MINCA2 > 0 || this.obj_Loyalty.MAXCA2 > 0 || this.obj_Loyalty.MINBA2 > 0 || this.obj_Loyalty.MAXBA2 > 0))
                                return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "MAXCA2") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (Number(this.obj_Loyalty.MAXCA2) <= Number(this.obj_Loyalty.MINCA2) && (this.obj_Loyalty.MINCA2 > 0 || this.obj_Loyalty.MAXCA2 > 0 || this.obj_Loyalty.MINBA2 > 0 || this.obj_Loyalty.MAXBA2 > 0))
                                return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "MINCA3") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (Number(this.obj_Loyalty.MINCA3) <= Number(this.obj_Loyalty.MAXCA2) && (this.obj_Loyalty.MINCA3 > 0 || this.obj_Loyalty.MAXCA3 > 0 || this.obj_Loyalty.MINBA3 > 0 || this.obj_Loyalty.MAXBA3 > 0))
                                return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "MAXCA3") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (Number(this.obj_Loyalty.MAXCA3) <= Number(this.obj_Loyalty.MINCA3) && (this.obj_Loyalty.MINCA3 > 0 || this.obj_Loyalty.MAXCA3 > 0 || this.obj_Loyalty.MINBA3 > 0 || this.obj_Loyalty.MAXBA3 > 0))
                                return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "MINCA4") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (Number(this.obj_Loyalty.MINCA4) <= Number(this.obj_Loyalty.MAXCA3) && (this.obj_Loyalty.MINCA4 > 0 || this.obj_Loyalty.MAXCA4 > 0 || this.obj_Loyalty.MINBA4 > 0 || this.obj_Loyalty.MAXBA4 > 0))
                                return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    if (value == "MAXCA4") {
                        if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                            if (Number(this.obj_Loyalty.MAXCA4) <= Number(this.obj_Loyalty.MINCA4) && (this.obj_Loyalty.MINCA4 > 0 || this.obj_Loyalty.MAXCA4 > 0 || this.obj_Loyalty.MINBA4 > 0 || this.obj_Loyalty.MAXBA4 > 0))
                                return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage[langKey1][langKey2]);
                        }
                    }

                    var validateObj = this.$v.obj_Loyalty[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[langKey1][langKey2]);
                    }

                }
            },
            getConditionAmountLabel() {
                switch (this.obj_Loyalty.LG) {
                    case 1:
                    case 11:
                        this.str_conditionAmountLabel = this.getLanguage["MEM"]["TA"];
                        break;
                    case 2:
                    case 12:
                        this.str_conditionAmountLabel = this.getLanguage["PM"]["CLA"];
                        break;
                    case 3:
                        this.str_conditionAmountLabel = this.getLanguage["PM"]["CDA"];
                        break;
                    default:
                        this.str_conditionAmountLabel = this.getLanguage["PM"]["CA"];
                        break;
                }
            },
            LoyaltyGroupChange(value) {

                this.getConditionAmountLabel();
                this.populateGameIds(true);

                var agi = 0;

                if (this.obj_Loyalty.AGIT) {
                    agi = this.obj_Loyalty.AGIT.split("-")[1];
                }
                this.genarateRBGame(agi);

                this.int_oldBonusGroup = value;
            },
            LoyaltyTypeChange() {
                switch (this.obj_Loyalty.LT) {
                    case 1:
                        this.str_loyaltyAmountLabel = this.getLanguage["PM"]["PA"];
                        this.str_loyaltyAmountMinPH = this.getLanguage["PM"]["PA"];
                        this.str_loyaltyAmountMaxPH = "";
                        break;
                    case 2:
                        this.str_loyaltyAmountLabel = "";
                        this.str_loyaltyAmountMinPH = this.getLanguage["PM"]["MIN"];
                        this.str_loyaltyAmountMaxPH = this.getLanguage["PM"]["MAX"] + " " + this.getLanguage["PM"]["AC21"];
                        break;
                    case 3:
                        this.str_loyaltyAmountLabel = this.getLanguage["PM"]["PAFR"];
                        this.str_loyaltyAmountMinPH = this.getLanguage["PM"]["PAFR"];
                        this.str_loyaltyAmountMaxPH = this.getLanguage["PM"]["PAPR"];
                        break;
                }
            },
            DisplayLevelLoyalty() {
                if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12)
                    return true;

                return false;
            },
            addLoyalty() {
                this.bool_LoyaltyCV = false;
                this.bool_fullLoading = true;

                this.obj_Loyalty = {
                    "I": 0,
                    "RS": 1,
                    "AGI": "",
                    "SAGAGI": null,
                    "AGIT": null,
                    "LN": "",
                    "LG": null,
                    "LT": 2,
                    "S": 0,
                    "TOP": 0,
                    "CDT": null,
                    "CDV": "",
                    "MINCA": null,
                    "MAXCA": null,
                    "MINBA": null,
                    "MAXBA": null,
                    "BR": null,
                    "BGI": "",
                    "GameIds": [],
                    "BGame": [],
                    "RBGame": [],

                    "MINCA2": null,
                    "MAXCA2": null,
                    "MINBA2": null,
                    "MAXBA2": null,
                    "BR2": null,

                    "MINCA3": null,
                    "MAXCA3": null,
                    "MINBA3": null,
                    "MAXBA3": null,
                    "BR3": null,

                    "MINCA4": null,
                    "MAXCA4": null,
                    "MINBA4": null,
                    "MAXBA4": null,
                    "BR4": null,

                    "CI": null,
                    "CDO": null,
                    "DT": null,
                    "MCRB": null
                };

                this.arry_cateogry=[];
                this.bool_isAMV = true;
                this.bool_fullLoading = false;
                this.getConditionAmountLabel();
                this.LoyaltyTypeChange();

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_Loyalty.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_Loyalty.AGIT);
                    }
                }

            },
            editLoyalty(id) {
                var that = this;

                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.bool_LoyaltyCV = false;

                this.getDataApi(`/api/mloyalty/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.obj_Loyalty = Object.assign(that.obj_Loyalty, d.D);
                            that.int_oldBonusGroup = that.obj_Loyalty.LG;

                            if (that.obj_Loyalty.MINCA != null && that.obj_Loyalty.MINCA > 0) {
                                that.obj_Loyalty.MINCA = that.obj_Loyalty.MINCA.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINCA = 0.00;
                            }

                            if (that.obj_Loyalty.MAXCA != null && that.obj_Loyalty.MAXCA > 0) {
                                that.obj_Loyalty.MAXCA = that.obj_Loyalty.MAXCA.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXCA = 0.00;
                            }

                            if (that.obj_Loyalty.MINBA != null && that.obj_Loyalty.MINBA > 0) {
                                if (that.obj_Loyalty.LT == 3)
                                    that.obj_Loyalty.MINBA = that.obj_Loyalty.MINBA.toFixed(0);
                                else
                                    that.obj_Loyalty.MINBA = that.obj_Loyalty.MINBA.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINBA = 0.00;
                            }

                            if (that.obj_Loyalty.MAXBA != null && that.obj_Loyalty.MAXBA > 0) {
                                that.obj_Loyalty.MAXBA = that.obj_Loyalty.MAXBA.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXBA = 0.00;
                            }

                            if (that.obj_Loyalty.BR != null && that.obj_Loyalty.BR > 0) {
                                that.obj_Loyalty.BR = that.obj_Loyalty.BR.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.BR = 0.00;
                            }

                            // 2nd set
                            if (that.obj_Loyalty.MINCA2 != null && that.obj_Loyalty.MINCA2 > 0) {
                                that.obj_Loyalty.MINCA2 = that.obj_Loyalty.MINCA2.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINCA2 = 0.00;
                            }

                            if (that.obj_Loyalty.MAXCA2 != null && that.obj_Loyalty.MAXCA2 > 0) {
                                that.obj_Loyalty.MAXCA2 = that.obj_Loyalty.MAXCA2.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXCA2 = 0.00;
                            }

                            if (that.obj_Loyalty.MINBA2 != null && that.obj_Loyalty.MINBA2 > 0) {
                                that.obj_Loyalty.MINBA2 = that.obj_Loyalty.MINBA2.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINBA2 = 0.00;
                            }

                            if (that.obj_Loyalty.MAXBA2 != null && that.obj_Loyalty.MAXBA2 > 0) {
                                that.obj_Loyalty.MAXBA2 = that.obj_Loyalty.MAXBA2.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXBA2 = 0.00;
                            }

                            if (that.obj_Loyalty.BR2 != null && that.obj_Loyalty.BR2 > 0) {
                                that.obj_Loyalty.BR2 = that.obj_Loyalty.BR2.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.BR2 = 0.00;
                            }

                            //// 3rd set
                            if (that.obj_Loyalty.MINCA3 != null && that.obj_Loyalty.MINCA3 > 0) {
                                that.obj_Loyalty.MINCA3 = that.obj_Loyalty.MINCA3.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINCA3 = 0.00;
                            }

                            if (that.obj_Loyalty.MAXCA3 != null && that.obj_Loyalty.MAXCA3 > 0) {
                                that.obj_Loyalty.MAXCA3 = that.obj_Loyalty.MAXCA3.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXCA3 = 0.00;
                            }

                            if (that.obj_Loyalty.MINBA3 != null && that.obj_Loyalty.MINBA3 > 0) {
                                that.obj_Loyalty.MINBA3 = that.obj_Loyalty.MINBA3.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINBA3 = 0.00;
                            }

                            if (that.obj_Loyalty.MAXBA3 != null && that.obj_Loyalty.MAXBA3 > 0) {
                                that.obj_Loyalty.MAXBA3 = that.obj_Loyalty.MAXBA3.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXBA3 = 0.00;
                            }

                            if (that.obj_Loyalty.BR3 != null && that.obj_Loyalty.BR3 > 0) {
                                that.obj_Loyalty.BR3 = that.obj_Loyalty.BR3.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.BR3 = 0.00;
                            }

                            //// 4th set
                            if (that.obj_Loyalty.MINCA4 != null && that.obj_Loyalty.MINCA4 > 0) {
                                that.obj_Loyalty.MINCA4 = that.obj_Loyalty.MINCA4.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINCA4 = 0.00;
                            }

                            if (that.obj_Loyalty.MAXCA4 != null && that.obj_Loyalty.MAXCA4 > 0) {
                                that.obj_Loyalty.MAXCA4 = that.obj_Loyalty.MAXCA4.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXCA4 = 0.00;
                            }

                            if (that.obj_Loyalty.MINBA4 != null && that.obj_Loyalty.MINBA4 > 0) {
                                that.obj_Loyalty.MINBA4 = that.obj_Loyalty.MINBA4.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MINBA4 = 0.00;
                            }

                            if (that.obj_Loyalty.MAXBA4 != null && that.obj_Loyalty.MAXBA4 > 0) {
                                that.obj_Loyalty.MAXBA4 = that.obj_Loyalty.MAXBA4.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.MAXBA4 = 0.00;
                            }

                            if (that.obj_Loyalty.BR4 != null && that.obj_Loyalty.BR4 > 0) {
                                that.obj_Loyalty.BR4 = that.obj_Loyalty.BR4.toFixed(2);
                            }
                            else {
                                that.obj_Loyalty.BR4 = 0.00;
                            }

                            var gameIds = [];
                            if (that.obj_Loyalty.BGI != null && that.obj_Loyalty.BGI.length > 0) {
                                gameIds = that.obj_Loyalty.BGI.split(',');
                            }

                            that.$set(that.$data.obj_Loyalty, 'GameIds', gameIds);

                            if (that.obj_Loyalty.AGI != 0) {
                                that.obj_Loyalty.AGIT = "3-" + that.obj_Loyalty.AGI;
                                that.RenderAgentGroupChange(that.obj_Loyalty.AGIT, false, that.populateGameIds);
                            }

                            if (that.obj_Loyalty.SAGAGI != 0) {
                                that.RenderSubAgentGroupChange(that.obj_Loyalty.SAGAGI, false, that.populateGameIds);
                            }
                            that.old_TOP = that.obj_Loyalty.TOP;
                            that.CurrencyChange(that.obj_Loyalty.CI)

                            that.getConditionAmountLabel();
                            that.LoyaltyTypeChange();

                            that.bool_isAMV = true;
                        }
                    });
            },
            populateGameIds(isLoyaltyGroupChange = false) {
                // clear the gameids if agent group id change
                if (!isLoyaltyGroupChange)
                    this.obj_Loyalty.GameIds = [];
                // clear the gameids only if promotion group change from rebate to non rebate or vice versa
                else if ((this.obj_Loyalty.LG == 1 && this.int_oldBonusGroup != 1) || (this.obj_Loyalty.LG != 1 && this.int_oldBonusGroup == 1))
                    this.obj_Loyalty.GameIds = [];

                if (this.obj_Loyalty.LG == 1 && this.dd_game != null && this.dd_game.length > 0) {

                    // if PGame is blank, push all in
                    if (this.obj_Loyalty.BGame == null || this.obj_Loyalty.BGame.length == 0) {

                        for (var i = 0; i < this.dd_game.length; i++) {
                            if (this.dd_game[i].children != null && this.dd_game[i].children.length > 0) {
                                for (var j = 0; j < this.dd_game[i].children.length; j++) {
                                    //    this.dd_game[i].children[j].rebate = 0.00;

                                    if (this.obj_Loyalty.GameIds.indexOf(this.dd_game[i].children[j].id) < 0) {
                                        this.obj_Loyalty.GameIds.push(this.dd_game[i].children[j].id);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < this.dd_game.length; i++) {
                            if (this.dd_game[i].children != null && this.dd_game[i].children.length > 0) {
                                for (var j = 0; j < this.dd_game[i].children.length; j++) {
                                    //    this.dd_game[i].children[j].rebate = 0.00;

                                    for (var k = 0; k < this.obj_Loyalty.BGame.length; k++) {
                                        if (this.dd_game[i].children[j].id == this.obj_Loyalty.BGame[k].GCI + "-" + this.obj_Loyalty.BGame[k].GPI) {
                                            this.dd_game[i].children[j].rebate = this.obj_Loyalty.BGame[k].BV.toFixed(2);

                                            if (this.obj_Loyalty.GameIds.indexOf(this.dd_game[i].children[j].id) < 0) {
                                                this.obj_Loyalty.GameIds.push(this.dd_game[i].children[j].id);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            updateAllRebate() {
                if (this.dd_game != null && this.dd_game.length > 0) {
                    var games = this.deepClone(this.dd_game);

                    for (var i = 0; i < games.length; i++) {
                        if (games[i].children != null && games[i].children.length > 0) {
                            for (var j = 0; j < games[i].children.length; j++) {
                                if (this.obj_Loyalty.GameIds.indexOf(games[i].children[j].id) >= 0) {
                                    var rebate = parseFloat(this.obj_Loyalty.BR);
                                    if (!isNaN(rebate))
                                        games[i].children[j].rebate = rebate.toFixed(2);
                                }
                            }
                        }
                    }

                    this.$set(this.$data, 'dd_game', games);
                }
            },
            toggleRebateInput(gameId) {
                if (gameId == null) {
                    return false;
                }
                else if (this.obj_Loyalty.GameIds == null || this.obj_Loyalty.GameIds.length == 0) {
                    return true;
                }
                else if (this.obj_Loyalty.GameIds.indexOf(gameId) >= 0) {
                    return false;
                }
                else
                    return true;
            },
            saveLoyalty() {
                var that = this;
                if (this.obj_Loyalty.AGIT != null && this.obj_Loyalty.AGIT.length > 0) {
                    var agi = this.obj_Loyalty.AGIT.split("-");
                    this.obj_Loyalty.AGI = agi[1];
                }

                if (this.obj_Loyalty.GameIds != null && this.obj_Loyalty.GameIds.length > 0) {
                    this.obj_Loyalty.BGI = this.obj_Loyalty.GameIds.join(',');
                } else {
                    this.obj_Loyalty.BGI = "";
                }

                this.bool_gameRebateMissing = false;
                //// populate PGame if the loyalty group is 1
                if (this.obj_Loyalty.LG == 1) {
                    if (this.obj_Loyalty.GameIds != null && this.obj_Loyalty.GameIds.length > 0) {
                        this.obj_Loyalty.BGame = [];

                        for (var i = 0; i < this.dd_game.length; i++) {
                            if (this.dd_game[i].children != null && this.dd_game[i].children.length > 0) {
                                for (var j = 0; j < this.dd_game[i].children.length; j++) {
                                    if (this.obj_Loyalty.GameIds.indexOf(this.dd_game[i].children[j].id) >= 0) {
                                        var gcpi = this.dd_game[i].children[j].id.split("-");

                                        this.obj_Loyalty.BGame.push({
                                            "I": 0,
                                            "RS": 2,
                                            //"GI": this.dd_game[i].children[j].id,
                                            "GCI": gcpi[0],
                                            "GPI": gcpi[1],
                                            "BV": this.dd_game[i].children[j].rebate
                                        });
                                    }
                                }
                            }
                        }
                    }
                    else {
                        this.bool_gameRebateMissing = true;
                    }
                }

                this.bool_LoyaltyCV = true;
                this.$v.obj_Loyalty.$touch();
                var formValid = true;
                if (this.obj_Loyalty.CDT == 0)
                    formValid = false;
                else if (!this.obj_Loyalty.CDV || (this.obj_Loyalty.CDV && (isNaN(this.obj_Loyalty.CDV) || this.obj_Loyalty.CDV < 0)))
                    if (this.obj_Loyalty.CDT == 4) {
                        this.obj_Loyalty.CDV = 0;
                    }
                    else {
                        formValid = false;
                    }
                else if (this.obj_Loyalty.LG == 3 && this.obj_Loyalty.DT == 0)
                    formValid = false;
                else if (this.obj_Loyalty.LT == 1 && this.obj_Loyalty.MINBA == 0 && this.obj_Loyalty.LG != 1)
                    formValid = false;
                else if (this.obj_Loyalty.LT == 2 && this.obj_Loyalty.BR == 0 && this.obj_Loyalty.LG != 1)
                    formValid = false;
                else if (this.obj_Loyalty.LG == 11 || this.obj_Loyalty.LG == 12) {
                    if (this.obj_Loyalty.LT == 2) {
                        if (this.obj_Loyalty.BR2 == 0 && (this.obj_Loyalty.MINCA2 > 0 || this.obj_Loyalty.MAXCA2 > 0 || this.obj_Loyalty.MAXBA2 > 0))
                            formValid = false;
                        else if (this.obj_Loyalty.BR3 == 0 && (this.obj_Loyalty.MINCA3 > 0 || this.obj_Loyalty.MAXCA3 > 0 || this.obj_Loyalty.MAXBA3 > 0))
                            formValid = false;
                        else if (this.obj_Loyalty.BR4 == 0 && (this.obj_Loyalty.MINCA4 > 0 || this.obj_Loyalty.MAXCA4 > 0 || this.obj_Loyalty.MAXBA4 > 0))
                            formValid = false;
                    } else if (this.obj_Loyalty.LT == 1) {
                        if (this.obj_Loyalty.MINBA2 == 0 && (this.obj_Loyalty.MINCA2 > 0 || this.obj_Loyalty.MAXCA2 > 0))
                            formValid = false;
                        else if (this.obj_Loyalty.MINBA3 == 0 && (this.obj_Loyalty.MINCA3 > 0 || this.obj_Loyalty.MAXCA3 > 0))
                            formValid = false;
                        else if (this.obj_Loyalty.MINBA4 == 0 && (this.obj_Loyalty.MINCA4 > 0 || this.obj_Loyalty.MAXCA4 > 0))
                            formValid = false;
                    }

                    if (Number(this.obj_Loyalty.MINCA2) < Number(this.obj_Loyalty.MAXCA) && (this.obj_Loyalty.MINCA2 > 0 || this.obj_Loyalty.MAXCA2 > 0 || this.obj_Loyalty.MINBA2 > 0 || this.obj_Loyalty.MAXBA2 > 0))
                        formValid = false;
                    else if (Number(this.obj_Loyalty.MINCA3) < Number(this.obj_Loyalty.MAXCA2) && (this.obj_Loyalty.MINCA3 > 0 || this.obj_Loyalty.MAXCA3 > 0 || this.obj_Loyalty.MINBA3 > 0 || this.obj_Loyalty.MAXBA3 > 0))
                        formValid = false;
                    else if (Number(this.obj_Loyalty.MINCA4) < Number(this.obj_Loyalty.MAXCA3) && (this.obj_Loyalty.MINCA4 > 0 || this.obj_Loyalty.MAXCA4 > 0 || this.obj_Loyalty.MINBA4 > 0 || this.obj_Loyalty.MAXBA4 > 0))
                        formValid = false;

                    else if (Number(this.obj_Loyalty.MINCA2) > Number(this.obj_Loyalty.MAXCA2) && (this.obj_Loyalty.MINCA2 > 0 || this.obj_Loyalty.MAXCA2 > 0 || this.obj_Loyalty.MINBA2 > 0 || this.obj_Loyalty.MAXBA2 > 0))
                        formValid = false;
                    else if (Number(this.obj_Loyalty.MINCA3) > Number(this.obj_Loyalty.MAXCA3) && (this.obj_Loyalty.MINCA3 > 0 || this.obj_Loyalty.MAXCA3 > 0 || this.obj_Loyalty.MINBA3 > 0 || this.obj_Loyalty.MAXBA3 > 0))
                        formValid = false;
                    else if (Number(this.obj_Loyalty.MINCA4) > Number(this.obj_Loyalty.MAXCA4) && (this.obj_Loyalty.MINCA4 > 0 || this.obj_Loyalty.MAXCA4 > 0 || this.obj_Loyalty.MINBA4 > 0 || this.obj_Loyalty.MAXBA4 > 0))
                        formValid = false;
                }

                //if (!this.$v.obj_Loyalty.$error && !this.bool_gameRebateMissing && formValid)
                if (!this.$v.obj_Loyalty.$error && formValid) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/mloyalty/s`, this.obj_Loyalty,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;   
                            if (s) {
                                that.bool_isAMV = false;
                                that.getLoyaltyList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_Loyalty"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeLoyalty(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/mloyalty/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getLoyaltyList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            updateStatus(d) {
                if (d.S == 0) {
                    this.$fire({
                        title: this.getLanguage["MEM"]["USM"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            var that = this;

                            this.postDataApi(`/api/mloyalty/us`, d,
                                function (d, s) {
                                    that.bool_fullLoading = false;

                                    if (s) {
                                        that.bool_isAMV = false;
                                        that.getLoyaltyList();
                                    }
                                });
                        }
                        else {
                            this.getLoyaltyList();
                        }
                    });
                } else {
                    this.bool_fullLoading = true;
                    var that = this;
                    d.RS = d.RS == 2 ? 1 : 2;

                    this.postDataApi(`/api/mloyalty/us`, d,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.bool_isAMV = false;
                                that.getLoyaltyList();
                            }
                        });
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: "",
                    endDate: ""
                };
            },
            selectAll(tabIndex) {
                this.bln_checkedAll[tabIndex] = (this.bln_checkedAll[tabIndex]) ? false : true;

                if (this.bln_checkedAll[tabIndex]) {
                    if (this.dd_game[tabIndex].children != null && this.dd_game[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_game[tabIndex].children.length; j++) {
                            //        this.dd_game[tabIndex].children[j].rebate = 0.00;

                            if (this.obj_Loyalty.GameIds.indexOf(this.dd_game[tabIndex].children[j].id) < 0) {
                                this.obj_Loyalty.GameIds.push(this.dd_game[tabIndex].children[j].id);
                            }
                        }

                    }
                } else {
                    if (this.dd_game[tabIndex].children != null && this.dd_game[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_game[tabIndex].children.length; j++) {
                            //        this.dd_game[tabIndex].children[j].rebate = 0.00;

                            var tempItem = this.obj_Loyalty.GameIds.indexOf(this.dd_game[tabIndex].children[j].id);

                            if (tempItem >= 0) {
                                this.obj_Loyalty.GameIds.splice(tempItem, 1);
                            }
                        }

                    }
                }

            },
            checkSelectAllButton() {
                for (const tabIndex in this.dd_game) {
                    this.bln_checkedAll[tabIndex] = false;
                    if (this.dd_game[tabIndex].children != null && this.dd_game[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_game[tabIndex].children.length; j++) {
                            //   this.dd_game[tabIndex].children[j].rebate = 0.00;

                            if (this.obj_Loyalty.GameIds.indexOf(this.dd_game[tabIndex].children[j].id) >= 0) {
                                this.bln_checkedAll[tabIndex] = true;
                            } else {
                                this.bln_checkedAll[tabIndex] = false;
                                break;
                            }
                        }
                    }
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.LYT';
            this.$parent.showSubSubMenu = '';
            this.getDropdownList();
            this.getCurrencyList();
            this.getLoyaltyList();
            this.getGameProviderList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        }
    }
</script>

<style scoped>
    .shorttext {
        height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/Loyalty.vue